import { ManageChatConnectors } from "./manage-chat-connectors";

export const ManageChatSidePanel = () => {
  return <ManageChatConnectors type="CONTACT_SIDE_BAR" />;
};
